import { SUBSCRIBE_CHANNEL } from '../constants';
import { LocalizedPropertyProps } from '../types';
import createEntityLocalizer from '../utils/createEntityLocalizer';

export const createLocalizedProperty = ({
    subscribeChannelKey = SUBSCRIBE_CHANNEL,
    handlerKey = 'localizeProperty',
} = {}) =>
    createEntityLocalizer<LocalizedPropertyProps>({
        subscribeChannelKey,
        handlerKey,
        displayName: 'LocalizedProperty',
        entityName: 'property',
    });

export default createLocalizedProperty();
